<div class="manage-generator-autocomplete">
  <div
    class="manage-generator-autocomplete__control"
    [class.manage-generator-autocomplete__control--compact]="size === 'compact'"
    [class.manage-generator-autocomplete__control--disabled]="disabled"
  >
    @if (showSuggestionCheckbox && selectedSuggestions.length) {
      <div class="manage-generator-autocomplete__selected-preview">
        @for (suggestion of getVisibleSelectedSuggestions(); track trackBySuggestion($index, suggestion)) {
          <span class="manage-generator-autocomplete__selected-name">{{ getSuggestionLabel(suggestion) }}</span>
        }
        @if (getHiddenSelectedSuggestionCount() > 0) {
          <span class="manage-generator-autocomplete__selected-more">...</span>
        }
      </div>
    }
    <input
      [id]="inputId || null"
      class="manage-generator-autocomplete__input app-form-input"
      type="text"
      [placeholder]="placeholder"
      [value]="inputValue"
      [disabled]="disabled"
      (input)="handleInput($event)"
      (focus)="handleFocus($event)"
      (blur)="handleBlur($event)"
      autocomplete="off"
    />

    @if (dropdown) {
      <button
        type="button"
        class="manage-generator-autocomplete__dropdown"
        [disabled]="disabled"
        (click)="handleDropdownClick($event)"
        aria-label="Open suggestions"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="m6 9 6 6 6-6"></path>
        </svg>
      </button>
    }
  </div>

  @if (panelOpen) {
    <div class="manage-generator-autocomplete__panel">
      @if (suggestions.length) {
        @for (suggestion of suggestions; track trackBySuggestion($index, suggestion)) {
          <button
            type="button"
            class="manage-generator-autocomplete__option"
            (mousedown)="handlePanelMouseDown($event)"
            (click)="selectSuggestion(suggestion)"
          >
            @if (showSuggestionCheckbox) {
              <input type="checkbox" [checked]="isSuggestionSelected(suggestion)" tabindex="-1" aria-hidden="true" />
            }
            <span>{{ getSuggestionLabel(suggestion) }}</span>
          </button>
        }
      } @else {
        <div class="manage-generator-autocomplete__empty">No results found</div>
      }
    </div>
  }
</div>
